import { createAction } from '@ngrx/store';
import { LoadingData } from '../reducer/config.reducer';

export const sidebarToggle = createAction('[Sidebar] Toggle', (value?: boolean) => ({ value }));
export const isDataLoading = createAction('[Data] Loading', (data: LoadingData) => ({ data }));
export const isDataLoadingCompleted = createAction('[Data] Completed', (data: LoadingData) => ({ data }));
export const svgScaleUp = createAction('[SVG] Scale Up');
export const svgScaleDown = createAction('[SVG] Scale Down');
export const svgScaleReset = createAction('[SVG] Scale Reset');
export const hoverParts = createAction('[SVG] Hover Parts', (currentHoveredNumber: string) => ({
  currentHoveredNumber
}));
export const loadPage = createAction('[SVG] Load Page', (currentLoadedPage: string) => ({
  currentLoadedPage
}));
export const updateCurrentPageNumber = createAction('[SVG] Start Current Page Number', (currentPageNumber: number) => ({
  currentPageNumber
}));
export const updateStartPageNumber = createAction('[SVG] Start Page Number', (startPageNumber: number) => ({
  startPageNumber
}));
export const updateEndPageNumber = createAction('[SVG] End Page Number', (endPageNumber: number) => ({
  endPageNumber
}));
export const prevPage = createAction('[SVG] Load Prev');
export const nextPage = createAction('[SVG] Load Next');
export const updatePage = createAction('[SVG] Update Page', (pageNumber: number) => ({ pageNumber }));
export const updateUID = createAction('[UID] Update', (uid: string) => ({
  uid
}));
export const updateIsPartsVisible = createAction('[PARTS] Update is parts visible', (value?: boolean) => ({ value }));
export const updateIsBasketVisible = createAction('[BASKET] Update is basket visible', (value?: boolean) => ({ value }));
export const openBasket = createAction('[BASKET] Open basket');
export const closeBasketAndParts = createAction('[BASKET] Close basket and parts');

export const resetConfig = createAction('[CONFIG] Reset');
